module.exports = __webpack_public_path__ + "img/illustration-sleep-apnea.947c6e9c.svg";